export const Colors = {
  1: '#e73c3c',
  2: '#f4da2a',
  3: '#2764ff',
  4: '#8fcc25',
  5: '#843b70',
  6: '#28edd1',
};